class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
      event.target
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    this.updateToCartButton();
  }

  updateToCartButton() {
    setTimeout(() => {
      // add to cart button update if muster
      const addToCartButton = document.querySelector('.product-form__submit.tw-btn');
      if (addToCartButton && addToCartButton.dataset.isMuster === 'true') {
        // get variant id
        const formEl = addToCartButton.closest('form');
        const variantId = formEl.querySelector('input[name="id"]').value;

        let variantFound = false;
        const cartItems = document.querySelectorAll('.cart-item');
        cartItems.forEach((item) => {
          // get item variant id
          const itemVariantId = item.querySelector('input[name="updates[]"]')?.dataset?.quantityVariantId;
          if (itemVariantId === variantId) {
            variantFound = true;
            addToCartButton.setAttribute('disabled', 'disabled');
          }
        });

        if (!variantFound) {
          addToCartButton.removeAttribute('disabled');
        }
      }
    }, 1000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset?.id,
        selector: '.js-contents',
      },
    ].filter((section) => section.section);
  }

  updateQuantity(line, qtty, name, variantId, target) {
    let quantity = qtty;
    this.enableLoading(line);

    // myharry theme specific code START
    // update quantity in cart based on qtty step rules

    if (target) {
      const step = Number(target.getAttribute('step'));
      const min = Number(target.getAttribute('min'));

      if (quantity < min) {
        quantity = min;
      } else {
        quantity = Math.round(quantity / step) * step;
      }
    }
    // myharry theme specific code END

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // myharry theme specific code START
        if (parsedState.item_count === 0) {
          document.querySelector('.drawer__inner-empty')?.classList.remove('!tw-hidden');
          document.querySelector('.drawer__inner-not-empty')?.classList.add('!tw-hidden');
        } else {
          // get and update cart summary
          let itemsDom;
          Object.values(parsedState.sections).forEach((section) => {
            const html = new DOMParser().parseFromString(section, 'text/html');
            const itemsElements = html.querySelectorAll('.cart-item__item');
            if (itemsElements.length > 0) {
              itemsDom = html;
            }
          });

          if (itemsDom) {
            const itemsElements = itemsDom.querySelectorAll('.cart-item__item');
            let sumCompareAt = 0;
            let sumPrice = 0;

            let maxMusterCount = 1000; // high enough number to be able to use the Math.min
            let musterCount = 0;

            itemsElements.forEach((item) => {
              // update maxMusterCount
              const itemMaxMusterCount = Number(item.dataset.maxMusterCount);
              if (!isNaN(itemMaxMusterCount)) {
                maxMusterCount = Math.min(maxMusterCount, itemMaxMusterCount);
              }

              if (item.dataset.isMuster === 'true') {
                musterCount += 1;
              }

              const compareAtEl = item.querySelector('.cart-item__compare-at-price');
              const priceEl = item.querySelector('.cart-item__price');
              if (compareAtEl) {
                const compareAtPrice = Number(compareAtEl.dataset.money);
                sumCompareAt += compareAtPrice / 100;
              }
              if (priceEl) {
                const price = Number(priceEl.dataset.money);
                sumPrice += price / 100;
              }
            });

            // update checkout buttons and warning texts regarding muster count
            document
              .querySelector('.cart__quick-checkout-buttons')
              ?.classList.toggle('tw-hidden', musterCount > maxMusterCount);
            document
              .querySelector('.cart-checkout__muster-max')
              ?.classList.toggle('tw-hidden', musterCount <= maxMusterCount);

            if (musterCount > maxMusterCount) {
              document.querySelector('.main-cart__checkout-button')?.setAttribute('disabled', 'disabled');
            } else {
              document.querySelector('.main-cart__checkout-button')?.removeAttribute('disabled');
            }

            sumCompareAt = sumCompareAt.toFixed(2);
            sumPrice = sumPrice.toFixed(2);

            const compareAtlEl = document.querySelector('.mh-cart__base-price');
            if (compareAtlEl) {
              let compareAtElText = compareAtlEl.dataset.priceTemplate;
              let currency = compareAtlEl.dataset.currencySymbol;
              compareAtElText = compareAtElText.replace('{{ price }}', sumCompareAt + ' ' + currency);

              compareAtlEl.innerHTML = compareAtElText;
            }

            const youSaveEl = document.querySelector('.mh-cart__you-save');
            if (youSaveEl) {
              let youSaveText = youSaveEl.dataset.priceTemplate;
              let currency = youSaveEl.dataset.currencySymbol;
              let youSave = sumCompareAt - sumPrice;
              youSave = youSave.toFixed(2);
              youSaveText = youSaveText.replace('{{ price }}', youSave + ' ' + currency);

              youSaveEl.innerHTML = youSaveText;
            }

            const subtotalPriceEl = document.querySelector('.mh-cart__subtotal-price');
            if (subtotalPriceEl) {
              let currency = subtotalPriceEl.dataset.currencySymbol;
              let subtotalPriceText = sumPrice + ' ' + currency;
              subtotalPriceEl.innerHTML = subtotalPriceText;
            }

            const totalPriceEl = document.querySelector('.mh-cart__total-price');
            if (totalPriceEl) {
              let totalPriceText = totalPriceEl.dataset.priceTemplate;
              let currency = totalPriceEl.dataset.currencySymbol;
              totalPriceText = totalPriceText.replace('{{ price }}', sumPrice + ' ' + currency);

              document.querySelector('.mh-cart__total-price-text')?.classList.toggle('tw-max-w-[45%]', sumPrice < 1000);

              totalPriceEl.classList.toggle('tw-w-full', sumPrice > 999);
              totalPriceEl.innerHTML = totalPriceText;
            }
          }
        }
        // myharry theme specific code END

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        this.updateToCartButton();

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart-item:quantity-updated'));
        });
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
